import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _typeof from '@babel/runtime/helpers/typeof';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _wrapNativeSuper from '@babel/runtime/helpers/wrapNativeSuper';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { SubmenuMenuItem } from './itemTypes.js';

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ApplicationMenuEvents;
(function (ApplicationMenuEvents) {
  ApplicationMenuEvents["ItemsUpdated"] = "items-updated";
})(ApplicationMenuEvents || (ApplicationMenuEvents = {}));
var ApplicationMenu = /*#__PURE__*/function (_EventTarget) {
  _inherits(ApplicationMenu, _EventTarget);
  var _super = _createSuper(ApplicationMenu);
  function ApplicationMenu() {
    var _this;
    _classCallCheck(this, ApplicationMenu);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "_items", []);
    return _this;
  }
  _createClass(ApplicationMenu, [{
    key: "items",
    get: function get() {
      return this._items;
    },
    set: function set(value) {
      this._items = value;
      this.dispatchEvent(new Event(ApplicationMenuEvents.ItemsUpdated));
    }
  }, {
    key: "append",
    value: function append(menuItem) {
      var before = menuItem.before,
        after = menuItem.after;
      var referenceIndex = -1;
      if (before) {
        referenceIndex = findIndexByIdOrLabel(before, this._items);
        if (referenceIndex !== -1) {
          this._items.splice(referenceIndex, 0, menuItem);
        }
      }
      if (after && referenceIndex === -1) {
        referenceIndex = findIndexByIdOrLabel(after, this._items);
        if (referenceIndex !== -1) {
          this._items.splice(referenceIndex + 1, 0, menuItem);
        }
      }
      if (referenceIndex === -1) {
        this._items.push(menuItem);
      }
      // Sorting elements referring to the added
      this.items = orderItems(this._items, menuItem);
    }
  }, {
    key: "getMenuItemById",
    value: function getMenuItemById(id) {
      var _iterator = _createForOfIteratorHelper(this.items),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (item.id === id) {
            return item;
          }
          if (item.type === 'submenu') {
            var submenuItem = item.submenu.getMenuItemById(id);
            if (submenuItem) {
              return submenuItem;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return null;
    }
  }, {
    key: "getSubmenuMenuItemById",
    value: function getSubmenuMenuItemById(id) {
      var _iterator2 = _createForOfIteratorHelper(this.items),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;
          if (item.id === id && item.type === 'submenu') {
            return item;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return null;
    }
  }], [{
    key: "buildFromTemplate",
    value: function buildFromTemplate(template) {
      var menu = new ApplicationMenu();
      var items = template.map(function (i) {
        return 'submenu' in i ? new SubmenuMenuItem(i) : i;
      });
      menu.items = orderItems(items);
      return menu;
    }
  }]);
  return ApplicationMenu;
}( /*#__PURE__*/_wrapNativeSuper(EventTarget));
_defineProperty(ApplicationMenu, "menu", new ApplicationMenu());
_defineProperty(ApplicationMenu, "getApplicationMenu", function () {
  return ApplicationMenu.menu;
});
_defineProperty(ApplicationMenu, "setApplicationMenu", function (value) {
  ApplicationMenu.menu = value;
});
function findIndexByIdOrLabel(pattern, items) {
  return items.findIndex(function (x) {
    if (x.id && pattern.includes(x.id)) {
      return true;
    }
    return pattern.includes(x.label);
  });
}
function findReferenceIndex(references, arr, existsReferences) {
  var _loop = function _loop(j) {
    // Skipping references which absence in `arr`
    if (!existsReferences.has(references[j])) {
      return "continue";
    }
    return {
      v: arr.findIndex(function (x) {
        return x.id === references[j] || x.label === references[j];
      })
    };
  };
  for (var j = 0; j < references.length; ++j) {
    var _ret = _loop(j);
    if (_ret === "continue") continue;
    if (_typeof(_ret) === "object") return _ret.v;
  }
  return -1;
}
function orderItems(arr, afterAdding) {
  var orderedList = _toConsumableArray(arr);
  var references = new Set();
  if (afterAdding) {
    if (afterAdding.id) {
      references.add(afterAdding.id);
    }
    references.add(afterAdding.label);
  } else {
    arr.forEach(function (x) {
      if (x.id) {
        references.add(x.id);
      }
      references.add(x.label);
    });
  }
  for (var i = 0; i < arr.length; ++i) {
    var _arr$i = arr[i],
      after = _arr$i.after,
      before = _arr$i.before;
    if (before) {
      var referenceIndex = findReferenceIndex(before, arr, references);
      if (referenceIndex !== -1) {
        delete orderedList[i];
        orderedList[referenceIndex] = [arr[i], orderedList[referenceIndex]];
        continue;
      }
    }
    if (after) {
      var _referenceIndex = findReferenceIndex(after, arr, references);
      if (_referenceIndex !== -1) {
        delete orderedList[i];
        orderedList[_referenceIndex] = [orderedList[_referenceIndex], arr[i]];
        // noinspection UnnecessaryContinueJS
        continue;
      }
    }
  }
  return orderedList.flat();
}

export { ApplicationMenu, ApplicationMenuEvents, orderItems };
